import { render, staticRenderFns } from "./CrmMapping.vue?vue&type=template&id=5457ad2e&"
import script from "./CrmMapping.vue?vue&type=script&lang=js&"
export * from "./CrmMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports